import { Component, OnInit } from '@angular/core';
import { SelectItem, LazyLoadEvent, Message, ConfirmationService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTable } from "primeng/components/datatable/datatable";
import { EditFundingRequestModel, FundingRequest } from '../../../models/inModels/FundingRequest';
import { NotificationContentType } from '../../../models/inModels/MessageModel';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { FundingRequestService } from '../../../services/funding/funding-request.service';

@Component({
	selector: 'app-funding',
	templateUrl: './funding.component.html',
	styleUrls: ['./funding.component.css']
})
export class FundingComponent implements OnInit {
	id;
	items: FundingRequest[];
	model: EditFundingRequestModel;
	rows: SelectItem[];
	selectedRows: number;
	filteredRecords: number;
	rowEvent: LazyLoadEvent;
	loading: boolean;
	totalRecords: number;
	error: Message[];
	contentId: number;
	contentType: NotificationContentType;
	sendAllDialog = false;
	selectedFundingRequest = false;
	constructor(
		private route: ActivatedRoute,
		private requestService: FundingRequestService,
		private router: Router,
		private confirmationService: ConfirmationService,
		private auth: AuthenticationService) {
		this.loading = true;
		this.rows = [];
		this.rows.push({ label: '10', value: 10 });
		this.rows.push({ label: '25', value: 25 });
		this.rows.push({ label: '50', value: 50 });
		this.selectedRows = 10;
		this.id = this.route.snapshot.paramMap.get('Id');
	}

	ngOnInit() {

	}

	changeRows(event): void {
		this.load(this.rowEvent);
	}

	reset(dt: DataTable, gb: HTMLInputElement) {
		gb.value = '';
		dt.reset();
	}

	load(event: LazyLoadEvent): void {
		this.loading = true;
		event.rows = this.selectedRows;
		this.rowEvent = event;
		this.requestService.search(event).then(
			dataPager => {
				this.items = dataPager.Data;
				this.filteredRecords = dataPager.FilteredRecords;
				this.totalRecords = dataPager.TotalRecords;
				this.loading = false;
				console.log(this.items);
			},
			error => {
				this.loading = false;
				this.items = [];
				this.totalRecords = 0;
				this.filteredRecords = 0;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error });
			}
		);
	}

	delete(fundingRequest: FundingRequest) {
		this.confirmationService.confirm({
			message: `Are you sure you want to delete this funding request?`,
			header: 'Confirmation',
			icon: 'fa fa-trash-o',
			accept: () => {
				this.loading = true;
				this.requestService.delete(fundingRequest.Id).then(
					result => {
						this.loading = false;
						this.load(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
	}

	approve(fundingRequest: FundingRequest) {
		this.confirmationService.confirm({
			message: `Are you sure you want to approve this funding request?`,
			header: 'Confirmation',
			icon: 'fa fa-check',
			accept: () => {
				this.loading = true;
				this.requestService.approve(fundingRequest.Id).then(
					result => {
						this.loading = false;
						this.load(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
	}

	disapprove(fundingRequest: FundingRequest) {
		this.confirmationService.confirm({
			message: `Are you sure you want to disapprove this funding request?`,
			header: 'Confirmation',
			icon: 'fa fa-times',
			accept: () => {
				this.loading = true;
				this.requestService.disapprove(fundingRequest.Id).then(
					result => {
						this.loading = false;
						this.load(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
	}

	details(fundingRequest: FundingRequest) {
		
		this.requestService.get(fundingRequest.Id).then(
			result => {
				this.router.navigate([`/funding/details/${fundingRequest.Id}`]);
				console.log(result);
			},
			error => {
				
			});
	}

	review(fundingRequest: FundingRequest) {
		this.confirmationService.confirm({
			message: `Are you sure you want to move this funding request to review?`,
			header: 'Confirmation',
			icon: 'fa fa-times',
			accept: () => {
				this.loading = true;
				this.requestService.review(fundingRequest.Id).then(
					result => {
						this.loading = false;
						this.load(this.rowEvent);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
	}

	

	getFundingRequest(fundingRequest: FundingRequest) {
		this.loading = true;
		this.requestService.get(fundingRequest.Id).then(
			result => {
				this.model = new EditFundingRequestModel(result);
				console.log(this.model);
				this.loading = false;
			},
			error => {
				this.loading = false;
				this.error = [];
				this.error.push({ severity: 'error', summary: 'Error', detail: error})
				
			}
		)
	}

	sendFeedback(fundingRequest: FundingRequest) {
		this.confirmationService.confirm({
			message: `Are you sure you want to add feedback?`,
			header: 'Confirmation',
			icon: 'fa fa-times',
			accept: () => {
				this.loading = true;
				this.requestService.feedback(this.model).then(
					result => {
						this.loading = false;
						this.model = new EditFundingRequestModel(result);
						this.load(this.rowEvent);
						console.log(result);
					},
					error => {
						this.loading = false;
						this.error = [];
						this.error.push({ severity: 'error', summary: 'Error', detail: error });
					});
			}
		});
	}

	viewFunding(fundingRequest: FundingRequest) {
		this.getFundingRequest(fundingRequest);
		this.selectedFundingRequest = true;
		
	}
}



// WEBPACK FOOTER //
// ./src/app/components/funding/funding/funding.component.ts